import { TMenuRow } from "../../gui/Menu/Menu";
import DateRangeFilter from "../widgets/DateRangeFilter";
import PortUtils from "../../portlibs/PortUtils";
import Toolbar from "../widgets/Toolbar";
import AddIcon from "../../gui/Icons/AddIcon";
import ExportIcon from "../icons/ExportIcon";

export default function HomeToolbar(props:{onExport:Function}){
    const MenuOptions : TMenuRow<string>[] = [
        {id:"add",text:"New Equity",url:{hash:PortUtils.createHash("", "add")},icon:<AddIcon/>},
        {id:"export",text:"Export",onClick:() => props.onExport(),icon:<ExportIcon/>}
    ]
    return <Toolbar options={MenuOptions} showAll={true}><DateRangeFilter/></Toolbar>
}